/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'activateCustomerSystemGameTypesBySystemGameId',
    message: messages.SUCCESS_ACTIVATE_CUSTOMER_SYSTEM_GAME_TYPES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/system-game-types/:systemGameId/activate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE,
    requestSchema: requestSchemas.customerSystemGameTypes.activateCustomerSystemGameTypesBySystemGameId,
  },
  {
    action: 'deactivateCustomerSystemGameTypesBySystemGameId',
    message: messages.SUCCESS_DEACTIVATE_CUSTOMER_SYSTEM_GAME_TYPES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/system-game-types/:systemGameId/deactivate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DEACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE,
    requestSchema: requestSchemas.customerSystemGameTypes.deactivateCustomerSystemGameTypesBySystemGameId,
  },
  {
    action: 'getCustomerSystemGameTypesBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_SYSTEM_GAME_TYPES_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/system-game-types/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_SYSTEM_GAME_TYPE,
    requestSchema: requestSchemas.customerSystemGameTypes.getCustomerSystemGameTypesBySystemGameId,
    scopes: [
      scopes.CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DEFAULT,
    ],
  },
];
